import { render, staticRenderFns } from "./LandingTeacher.vue?vue&type=template&id=9133988c&"
import script from "./LandingTeacher.vue?vue&type=script&lang=js&"
export * from "./LandingTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports